<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("profile.mentorship.feedback.changeStages") }}
        {{ tag && tag.name }}
      </v-card-title>

      <v-card-text>
        <v-autocomplete
          v-model="toAssignMentorshipFeedbackIds"
          :items="mentorshipFeedbacks"
          multiple
          required
          item-value="id"
          :item-text="itemText"
        />
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">
          {{ $t("dialog.cancel") }}
        </v-btn>

        <v-btn @click="save" color="primary" text :loading="loading"
          >{{ $t("dialog.change") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MentorshipFeedbacksQuery from "@/graphql/queries/MentorshipFeedbacks.gql";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    assignedFeedbackForms: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      toAssignMentorshipFeedbackIds: [],
    };
  },
  watch: {
    assignedFeedbackForms() {
      this.resetSelection();
    },
  },
  methods: {
    resetSelection() {
      this.toAssignMentorshipFeedbackIds = this.assignedFeedbackForms.map(
        (item) => item.id
      );
    },
    hide() {
      this.$emit("update:loading", false);
      this.$emit("update:show", false);
      this.resetSelection();
    },
    save() {
      this.$emit("update:loading", true);
      this.$emit("change", this.toAssignMentorshipFeedbackIds);
    },
    itemText(item) {
      const f = this.$options.filters;
      let menteeSubmitted = "";
      let mentorSubmitted = "";
      if (item.menteeSubmittedForm) {
        menteeSubmitted = `!!! ${this.$t(
          "profile.mentorship.feedback.menteeSubmitted"
        )} ${f.date(item.menteeSubmittedForm.dateTime)}`;
      }
      if (item.mentorSubmittedForm) {
        mentorSubmitted = `!!! ${this.$t(
          "profile.mentorship.feedback.mentorSubmitted"
        )} ${f.date(item.mentorSubmittedForm.dateTime)}`;
      }
      return `${menteeSubmitted} ${mentorSubmitted} ${this.$t(
        "profile.mentorship.feedback.stage"
      )} ${item.stage} ${(item.form && item.form.nameLocale.value) || ""} ${
        item.revision
      }`;
    },
  },
  apollo: {
    mentorshipFeedbacks: {
      query: MentorshipFeedbacksQuery,
      variables() {
        return {
          all: false,
        };
      },
      update(data) {
        this.assignedFeedbackForms.forEach((item) => {
          const index = data.mentorshipFeedbacks.findIndex(
            (f) => f.id == item.id
          );
          if (index == -1) {
            data.mentorshipFeedbacks.push(item);
          }
          if (index) {
            data.mentorshipFeedbacks[index] = item;
          }
        });

        return data.mentorshipFeedbacks;
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
